import type {
  InvitationRepository,
  InvitationListOptions,
  InvitationPage,
} from '#/domain/invitation/InvitationRepository'
import type { Invitation } from '#/domain/invitation/Invitation'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainPage, type InvitationPageResponseDto } from './InvitationDto'

export class HttpInvitationRepository implements InvitationRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(options?: InvitationListOptions, search?: string): Promise<InvitationPage> {
    const params: Record<string, string> = {}
    if (options?.page !== undefined) params.page = String(options.page)
    if (options?.itemsPerPage !== undefined) params.itemsPerPage = String(options.itemsPerPage)
    if (options?.sortBy) params.sortBy = options.sortBy
    if (options?.sortDesc) params.sortDesc = options.sortDesc
    if (search) params.search = search

    const raw = await this.http.get<InvitationPageResponseDto>('auth0/invite', {
      searchParams: new URLSearchParams(params),
    })
    return toDomainPage(raw)
  }

  async create(invitations: Invitation[], organizationId?: string): Promise<void> {
    await this.http.post<void>('auth0/invite', {
      json: { Invitations: invitations },
      searchParams: organizationId ? new URLSearchParams({ organizationId }) : undefined,
    })
  }

  async resend(invitation: Invitation): Promise<void> {
    await this.http.put<void>('auth0/invite', { json: invitation })
  }
}
